// extracted by mini-css-extract-plugin
export default {"V2FormTextArea":"V2FormTextArea--A3xE7","V2FormTextAreaDisabled":"V2FormTextAreaDisabled--xdrC9","markerAnimationScale":"markerAnimationScale--KsCzW"};